import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c965aae4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 bg-light p-3" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Rate List", -1))
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-striped table-sm" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Distance Type"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Per Unit Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Base Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Base Unit"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "is Base Rate"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "is Reference Rate"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "is Advance Rate"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "user"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "text-start" }
const _hoisted_21 = { class: "btn-group mr-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { colspan: "11" }
const _hoisted_25 = { class: "table table-sm" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "#", -1))
const _hoisted_27 = {
  scope: "col",
  class: "text-start"
}
const _hoisted_28 = {
  scope: "col",
  class: "text-start"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Range price ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Rate range Type ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Action", -1))
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = { class: "text-start" }
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "text-start" }
const _hoisted_37 = { class: "text-start" }
const _hoisted_38 = { class: "btn-group mr-2" }
const _hoisted_39 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/rates/create",
              class: "btn btn-sm btn-primary align-self-center"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Add Rate")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rates, (rate) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: rate.id
                  }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString(rate.id), 1),
                      _createElementVNode("td", _hoisted_11, _toDisplayString(rate.distance_type), 1),
                      _createElementVNode("td", _hoisted_12, _toDisplayString(rate.per_unit_price), 1),
                      _createElementVNode("td", _hoisted_13, _toDisplayString(rate.base_price), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(rate.base_unit), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(rate.is_base_rate), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(rate.is_reference_rate), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(rate.is_advance_rate), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(rate.city?.name), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(rate.user?.full_name), 1),
                      _createElementVNode("td", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            class: "btn btn-sm btn-primary me-2",
                            onClick: ($event: any) => ($setup.select(rate.id))
                          }, " View", 8, _hoisted_22),
                          _createVNode(_component_router_link, {
                            to: `/rates/detail/${rate.id}`,
                            class: "btn btn-sm btn-success me-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Detail")
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createVNode(_component_router_link, {
                            to: `/rates/edit/${rate.id}`,
                            class: "btn btn-sm btn-secondary me-2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Edit")
                            ]),
                            _: 2
                          }, 1032, ["to"]),
                          _createElementVNode("a", {
                            class: "btn btn-sm btn-danger me-2",
                            onClick: ($event: any) => ($setup.del(rate.id))
                          }, " Delete", 8, _hoisted_23)
                        ])
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_24, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["overflow-hidden", $setup.selected=== rate.id ? 'show': 'hide' ])
                        }, [
                          _createVNode(_component_router_link, {
                            to: `/rateranges/create/${$setup.selected}`,
                            class: "btn btn-sm btn-secondary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Add Rate Range")
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createElementVNode("table", _hoisted_25, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_26,
                                _createElementVNode("th", _hoisted_27, "Start Range " + _toDisplayString(rate.distance_type), 1),
                                _createElementVNode("th", _hoisted_28, "End Range " + _toDisplayString(rate.distance_type), 1),
                                _hoisted_29,
                                _hoisted_30,
                                _hoisted_31
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rate.rateranges, (raterange) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: raterange.id
                                }, [
                                  _createElementVNode("td", _hoisted_32, _toDisplayString(raterange.id), 1),
                                  _createElementVNode("td", _hoisted_33, _toDisplayString(raterange.start_range), 1),
                                  _createElementVNode("td", _hoisted_34, _toDisplayString(raterange.end_range), 1),
                                  _createElementVNode("td", _hoisted_35, _toDisplayString(raterange.range_price), 1),
                                  _createElementVNode("td", _hoisted_36, _toDisplayString(raterange.rate_type), 1),
                                  _createElementVNode("td", _hoisted_37, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_component_router_link, {
                                        to: `/rateranges/${raterange.id}/edit`,
                                        class: "btn btn-sm btn-secondary me-2"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Edit")
                                        ]),
                                        _: 2
                                      }, 1032, ["to"]),
                                      _createElementVNode("a", {
                                        class: "btn btn-sm btn-danger me-2",
                                        onClick: ($event: any) => ($setup.delraterange(raterange.id))
                                      }, " Delete", 8, _hoisted_39)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 2)
                      ])
                    ])
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_pagination, {
      modelValue: _ctx.page,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
        _cache[1] || (_cache[1] = ($event: any) => ($setup.load($event)))
      ],
      pages: $setup.lastPage,
      "range-size": 1,
      "active-color": "#DCEDFF"
    }, null, 8, ["modelValue", "pages"])
  ], 64))
}